import {EventEmitter} from "events"
import {provide} from "vue"
import SocketClient from "xpark-shared/services/socket-client"
import {Topic} from "xpark-shared/topics"
import SettingsHelper from "./SettingsHelper"

export default class SocketHelper {
    public static socketClient = "socketClient"
    public static gameSocket = "gameSocket"
    public static rfidSocket = "rfidSocket"
    public static barCodeSocket = "barCodeSocket"

    public static connect(host: string, id: string): SocketClient {
        const socket = new SocketClient(host, new EventEmitter())
        socket.connect()

        provide(id, socket)

        return socket
    }

    public static sendRfidDoorStatus(socketClient: SocketClient, success: boolean) {
        this.sendRfidStatus(socketClient, 1, success)
    }

    public static sendRfidStatus(socketClient: SocketClient, scanner: number, success: boolean) {
        socketClient.emit(Topic.rfidStatus, {scanner, success})
    }

    private static doorTimeout = 0
    public static unlockDoor(socketClient: SocketClient) {
        const timeout = SettingsHelper.getSetting("doorLockTimeout")
        this.sendMoxaStatus(socketClient, "door", SocketHelper.DOOR_UNLOCKED)

        clearTimeout(this.doorTimeout)
        this.doorTimeout = setTimeout(() => {
            this.lockDoor(socketClient)
        }, timeout * 1000)
    }

    private static DOOR_LOCKED = true
    private static DOOR_UNLOCKED = false
    public static lockDoor(socketClient: SocketClient) {
        const settings = (window as any)._settings
        if (settings.lockDoors === true) {
            this.sendMoxaStatus(socketClient, "door", SocketHelper.DOOR_LOCKED)
        }
    }

    public static sendMoxaStatus(socketClient: SocketClient, moxaIds: string[] | string, state: boolean) {
        const request = {state} as any
        request.deviceIds = Array.isArray(moxaIds) ? moxaIds : [moxaIds]
        socketClient.emit(Topic.digitalOutput, request)
    }

}
